import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ResidentEnrollmentFields from './ResidentEnrollmentFields'

export const ResidentEnrollmentCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <ResidentEnrollmentFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default ResidentEnrollmentCreate
